import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'pulse-title',
  templateUrl: './title.component.html',
  styleUrls: ['./title.component.scss'],
})
export class TitleComponent implements OnInit {
  @Input() title: string = "This is a title";

  constructor() {}

  ngOnInit(): void {}
}
